module.exports = __webpack_public_path__ + "static/media/sonyproduct1banner2.78102880.jpg";